import {makeStyles, IconButton} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, {useState} from 'react';

import {AddBox, Edit} from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: '300px',
  },
}));

let dialogCount = 0;

/**
 * Renders a form in a dialog.
 *
 * Uncontrolled (default): renders its own icon button that opens the dialog.
 *
 * Controlled: pass `open` and `onClose` and no trigger button is rendered.
 * Use this when the dialog is opened from a material-table action, which
 * already renders its own button. Rendering PopupForm's button inside it
 * nests a <button> inside a <button> (WCAG 4.1.2).
 */
export default function PopupForm({
  component: Component,
  title,
  open: controlledOpen,
  onClose,
  ...rest
}) {
  const classes = useStyles();
  const [titleId] = useState(() => `popup-form-title-${++dialogCount}`);
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : uncontrolledOpen;

  const setOpen = (value) => {
    const next = typeof value === 'function' ? value(open) : value;
    if (isControlled) {
      if (!next && onClose) onClose();
    } else {
      setUncontrolledOpen(next);
    }
  };

  const {editIcon, ...componentProps} = rest;

  return (
    <>
      {!isControlled && (
        <IconButton
          color="primary"
          onClick={() => setOpen(true)}
          aria-label={title}
        >
          {editIcon ? <Edit /> : <AddBox />}
        </IconButton>
      )}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        classes={{root: classes.root}}
        aria-labelledby={titleId}
      >
        <DialogTitle id={titleId}>{title}</DialogTitle>
        <DialogContent>
          <Component setOpen={setOpen} {...componentProps} />
        </DialogContent>
      </Dialog>
    </>
  );
}
